import { RxComponent } from 'app/core/components/common/rx.component';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'itpx-add-image',
    templateUrl: './add-image.component.html',
    styleUrls: ['./add-image.component.css']
})
export class AddImageComponent extends RxComponent {

    private form: FormGroup;

    constructor(
        private fb: FormBuilder,
        private modalService: SmartModalService
    ) {
        super();
    }

    ngOnInit() {

        this.form = this.fb.group({
            width: [null],
            height: [null],
            auto: [1]
        });

        this.form.get('auto').valueChanges
            .startWith(1)
            .bindToLifecycle(this)
            .subscribe(auto => {
                let width = this.form.get('width');
                let height = this.form.get('height');
                auto ? width.disable() : width.enable();
                auto ? height.disable() : height.enable();
            })

    }

    onAdd() {
        this.modalService.sendResult(this.form.value);
    }

    onDismiss() {
        this.modalService.sendResult(null);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/template/editor/add-image/add-image.component.ts